import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  EnrichmentListResult,
  GetEnrichmentListParams
} from "../../recommendation.types";
import { requestGetEnrichmentList } from "./getEnrichmentList.request";

const useEnrichmentList = (
  params: GetEnrichmentListParams,
  options?: QueryOptions<EnrichmentListResult, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["recommendation", "enrichment", "list", params],
    queryFn: async () => await requestGetEnrichmentList(params),
    onError: toastServerError,
    keepPreviousData: true,
    ...options
  });

  return { items: data?.items ?? [], total: data?.total ?? 0, ...rest };
};

export default useEnrichmentList;
